"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          padding: 0,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#0D1117",
          color: "#f4f4f5",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <div style={{ textAlign: "center", padding: "24px" }}>
          <img
            src="https://d1oah9jnmmw7bq.cloudfront.net/logos/Trackstack_symbol_01.png"
            alt="Trackstack"
            width={48}
            height={48}
            style={{ marginBottom: "24px" }}
          />
          <h1
            style={{
              fontSize: "48px",
              fontWeight: 700,
              margin: "0 0 8px",
              color: "#ff4757",
            }}
          >
            500
          </h1>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: 600,
              margin: "0 0 12px",
            }}
          >
            Something went wrong
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#a1a1aa",
              margin: "0 0 32px",
              maxWidth: "400px",
              lineHeight: 1.5,
            }}
          >
            A critical error occurred. Please try again or refresh the page.
          </p>
          <button
            onClick={reset}
            style={{
              backgroundColor: "#7B5BFF",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
